import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatLegacyCardModule} from "@angular/material/legacy-card";
import {LeadPlaceComponent} from './lead-place/lead-place.component';
import {CtButtonModule, CtModelModule} from "@ctsolution/ct-framework";
import {MatDividerModule} from "@angular/material/divider";
import {TranslateModule} from "@ngx-translate/core";
import {FlexLayoutModule} from "@angular/flex-layout";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {LeadPlaceListComponent} from "./lead-place-list.component";


@NgModule({
  declarations: [
    LeadPlaceListComponent,
    LeadPlaceComponent
  ],
  exports: [
    LeadPlaceListComponent
  ],
  imports: [
    CommonModule,
    MatLegacyCardModule,
    CtButtonModule,
    CtModelModule,
    MatDividerModule,
    TranslateModule,
    FlexLayoutModule,
    MatIconModule,
    MatButtonModule
  ]
})
export class LeadPlaceListModule {
}
